"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServAw = void 0;
const goog_base_1 = require("./goog_base");
/**
 * AdWords
 */
class AnServAw extends goog_base_1.AnServGoogBase {
    static buildConversionTarget(pixelId, conversionLabel) {
        const ret = [pixelId, conversionLabel].join("/");
        return ret;
    }
    static sendTrackConversion(pixelId, conversionLabel, price = null, orderId = null) {
        const opts = {
            send_to: this.buildConversionTarget(pixelId, conversionLabel)
        };
        if (price !== null) {
            opts.value = price;
            opts.currency = "USD";
        }
        if (orderId !== null) {
            opts.transaction_id = orderId.toString();
        }
        this.sendCustEventNested(pixelId, "conversion", opts);
        return true;
    }
}
exports.AnServAw = AnServAw;
AnServAw.serviceName = "GoogleAdwords";
